<template>
  <!-- The avatar on the home page: the 2026 torso, standing at the bottom of
       the screen on phones and at the right edge on desktop. It is there while
       you're at the top of the page and scrolls away with the page (down on
       phones, down and out to the right on desktop, zooming in as it goes),
       driven by a GSAP ScrollTrigger. While it's showing, the nav links and
       the chat button are hidden (html.home-at-top), so the top of the page is
       the hero and the figure.
       Decorative, and only the face takes pointer events, so the rest of the
       figure never blocks the links it overlaps. The eyes follow the pointer
       and blink now and then; hovering the face makes them look at you, and
       pressing it winks the eye on the right of the screen, a lid drawn like
       the brows, held until you let go. On the face they hold still, and the
       right-hand brow lifts; pressing drops it into the wink.
       They keep looking at you until the pointer leaves the face.
       The drawing is avatar-2026-torso-nobg.svg, inline so the shirt can take
       the theme: brown in the light theme, yellow in the dark.
       Teleported to <body>, so it stands in front of the hero's text: inside
       the page it shared the page's stacking order and the letters drew over
       it. -->
  <teleport to="body">
  <div ref="figure" class="home-avatar" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 1125" focusable="false">
      <path d="M132.89,858.26c-2.34,.09-4.14,.99-6.03,2.07-1.89,1.08-3.87,2.79-5.31,4.23-1.35,1.53-2.34,2.88-3.06,4.68-.72,1.8-2.61-33.39-1.17,6.03,1.53,39.42,8.46,176.4,10.08,230.4s.09,75.78-.27,93.6c-.45,17.82-.72,7.83-2.07,13.5s-4.59,14.67-5.85,20.7c-1.26,6.03-1.8,2.97-1.62,15.3,.18,12.33,1.98,47.43,2.88,58.5,.81,10.98,.9,5.85,2.25,7.65,1.35,1.71-5.31,2.34,5.76,2.79,11.16,.54,79.86,.36,90.66,0,10.8-.27,3.33-.63,4.23-1.8,.99-1.17,1.44,11.61,1.53-5.31,0-16.83-.54-78.21-1.17-96.03-.63-17.82-.27-5.67-2.7-10.8-2.34-5.13-9.36-15.03-11.7-19.8-2.34-4.77-2.52-5.22-2.34-9,.09-3.78,.81-7.02,3.24-13.5,2.34-6.48,8.91-16.83,11.25-25.2,2.25-8.37,2.7,.27,2.43-25.2-.18-25.47-2.07-92.43-3.69-127.8-1.62-35.37-4.41-68.22-5.85-84.6-1.53-16.38-1.35-9.63-3.06-13.5s-.63-5.49-7.38-9.72c-6.75-4.23-56.19-12.87-63.03-15.66-6.84-2.88-5.67-1.62-8.01-1.53Z" fill="rgb(236, 150, 131)" fill-rule="evenodd"></path>
      <path d="M770.11,860.7c-1.89-.27-1.62-.99-6.21,.45-4.68,1.44-11.52,5.49-21.6,8.28-10.08,2.7-30.6,7.02-38.7,8.28-8.1,1.35-4.95,.72-9.9-.45-4.95-1.17-13.77-5.58-19.8-6.57-6.03-.9-12.15,.27-16.2,.9-4.05,.54-5.76,1.53-8.01,2.7-2.25,1.08-4.05,2.52-5.49,3.96-1.53,1.44-2.43,2.79-3.33,4.77-.9,1.89-1.44-14.22-2.16,7.02-.72,21.24-.63,87.48-2.16,120.6-1.44,33.12-3.96,50.85-6.75,78.3-2.7,27.45-7.74,70.38-9.72,86.4s-.54,5.4-1.98,9.9c-1.53,4.5-6.03,4.95-6.84,17.1-.72,12.15,1.53,45.36,2.25,55.8,.63,10.44,.63,4.77,1.8,6.93,1.08,2.25-6.57-3.69,4.95,6.21,11.43,9.9,51.93,43.92,63.72,53.37,11.79,9.36,4.5,2.79,7.2,3.24,2.7,.36,6.39,.27,8.91-.9,2.52-1.17,3.06-1.17,5.94-6.12,2.88-4.86,8.1-15.21,11.34-23.13,3.24-7.92,6.21-17.82,8.01-24.3s1.89-5.67,2.97-14.4-4.14-2.97,3.51-37.8c7.74-34.83,34.38-136.53,42.66-171s5.13-19.98,6.93-36c1.89-16.02,3.51-37.8,3.96-60.3,.54-22.5-.63-61.2-.99-74.7-.36-13.5-.36-4.14-1.08-6.12-.72-2.07-1.8-4.05-3.15-5.76s-3.33-3.51-5.04-4.59c-1.62-1.08-3.15-1.8-5.04-2.07Z" fill="rgb(236, 150, 131)" fill-rule="evenodd"></path>
      <path d="M712.08,597.95c-291.69-149.01-320.96-77.02-490.26-3.42-99.54,42.21-102.8,185.82-130.26,274.92-6.74,32.59,82.57,56.71,112.03,61.19,31.8-11.12,12.07,225.63,18.82,258.51,5.93,28.87,150.84,16.34,189.79,18.21,201.64,9.65,212.46-36.83,212.46-36.83,11.04-26.64,13.62-236.6,13.62-236.6,34.77-2.17,124.73-8.99,154.04-38.42,7.42-7.45,8.39-10.01,7.25-13.82-23.72-78.95-21.18-224.72-87.5-283.73Z" class="shirt" fill-rule="evenodd"></path>
      <path d="M267.53,281.08h-4.78c-26.86,0-34.32,16.6-34.88,34.91-1.53,49.65,31.01,71.2,43.34,66.85,3.08-1.09,10.77,4.14,13.53,2.96" fill="rgb(236, 150, 131)"></path>
      <g>
        <path data-name="Shape 8 -Copy-3" d="M269.96,310.54c-26.81-12.29-23.02,26.19-11.85,37.67" fill="none" stroke-linecap="round" stroke="rgb(190, 105, 90)" stroke-width="14px"></path>
        <path data-name="Shape 9 -Copy-3" d="M269.65,310.92c-14.21,2.32-19.54,20.4,2.21,25.97" fill="none" stroke-linecap="round" stroke="rgb(190, 105, 90)" stroke-width="14px"></path>
      </g>
      <path d="M326.3,532.87c-4.13,32.27,17.15,58.1,45.09,71.32,63.82,29.13,130.49-26.08,152.82-83.34-2.43-3.24-11.43-11.7-14.31-15.3-9.12-11.53-5.52-94.26,1.26-108.81l-184.86,136.13Z" fill="rgb(236, 150, 131)"></path>
      <path d="M480.13,454.1c-.93-4.13-14.43,16.71-18.97,20.34-17.32,17.5-44.81,39.4-66.55,49.84-13.49,9.5-56.9,10.68-58.57,17.56-.56,5.83,5.12,19.34,11.69,21.36,47.01,14.47,120.09-59.96,132.41-109.1Z" fill-rule="evenodd" fill="rgb(190, 105, 90)"></path>
      <path data-name="Shape 6 -Copy-3" d="M249.77,398.86c-2.23,0-3.34-1.11-3.34-3.34v-20.31c0-2.23,1.11-3.34,3.34-3.34h20.31c2.23,0,3.34,1.11,3.34,3.34v20.31c0,2.23-1.11,3.34-3.34,3.34h-20.31Z" fill="rgb(252, 177, 56)"></path>
      <path d="M203.25,704.6c-.27,15.75-3.87,51.12-1.71,94.68,2.16,43.65,11.25,112.5,14.58,167.04,3.42,54.54,4.59,133.47,5.49,160.2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="shirt-fold" stroke-width="16.2px"></path>
      <path d="M634.2,705.97c-1.8,13.14-10.26,36.72-10.62,78.93-.45,42.21,7.47,125.82,8.19,174.24,.72,48.42-1.53,92.34-3.69,116.19-2.16,23.94-4.23,20.43-9.45,27.09-5.22,6.66-18.18,10.8-21.87,12.96" fill="none" stroke-linecap="round" stroke-linejoin="round" class="shirt-fold" stroke-width="16.2px"></path>
      <path ref="face" class="face" @pointerenter="onFaceEnter" @pointerleave="onFaceLeave" @pointerdown="onFacePress" data-name="Combined-Shape" d="M512.61,385.59c-2.88,29.41-14.49,43.96-29.92,63.22-56.01,69.95-64.66,89.6-132.82,89.6-23.38,0-73.15-8.89-83.29-89.6l-20.62-211.72c0-71.63,40.11-132.62,132.97-132.62,112.99,0,150.88,69.09,150.88,132.62v43.77h4.78c26.86,0,34.32,16.6,34.88,34.91,1.53,49.65-31.01,71.2-43.34,66.85-3.08-1.09-10.77,4.14-13.53,2.96Z" fill="rgb(236, 150, 131)"></path>
      <path data-name="Shape 6 -Copy-3" d="M510.28,398.86c-2.23,0-3.34-1.11-3.34-3.34v-20.31c0-2.23,1.11-3.34,3.34-3.34h20.31c2.23,0,3.34,1.11,3.34,3.34v20.31c0,2.23-1.11,3.34-3.34,3.34h-20.31Z" fill="rgb(252, 177, 56)"></path>
      <g data-name="Group-10">
        <path data-name="Shape 8 -Copy-3" d="M527.19,310.54c26.81-12.29,23.02,26.19,11.85,37.67" fill="none" stroke-linecap="round" stroke="rgb(190, 105, 90)" stroke-width="14px"></path>
        <path data-name="Shape 9 -Copy-3" d="M527.51,310.92c14.21,2.32,19.54,20.4-2.21,25.97" fill="none" stroke-linecap="round" stroke="rgb(190, 105, 90)" stroke-width="14px"></path>
      </g>
      <g>
        <g>
          <path data-name="Shape 10 -Copy-3" d="M286.41,293.67c-2.92,0-6.64-2.19-6.64-6.64,0-2.19,1.46-4.45,2.92-5.18-1.46-.73-2.19-.73-3.64-.73-7.37,0-13.28,5.18-13.28,13.28s5.18,13.28,13.28,13.28c7.37,0,13.28-5.18,13.28-13.28,0-1.46,0-2.19-.73-3.64-1.46,2.19-3,2.92-5.18,2.92Z" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(127, 75, 79)" fill="rgb(127, 75, 79)" stroke-width="3.69px" ref="eyeL" class="fa-eye fa-eye-l"></path>
          <path data-name="Shape 11 -Copy-3" d="M395.05,293.67c-2.92,0-6.64-2.19-6.64-6.64,0-2.19,1.46-4.45,2.92-5.18-1.46-.73-2.19-.73-3.64-.73-7.37,0-13.28,5.18-13.28,13.28s5.18,13.28,13.28,13.28c7.37,0,13.28-5.18,13.28-13.28,0-1.46,0-2.19-.73-3.64-.73,2.19-3,2.92-5.18,2.92Z" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(127, 75, 79)" fill="rgb(127, 75, 79)" stroke-width="3.69px" ref="eyeR" class="fa-eye fa-eye-r"></path>
          <!-- The wink: a closed lid drawn as a stroke like the brows, shown in
               place of the right-hand eye while the face is pressed. -->
          <path class="wink" d="M375.5,291 Q388.5,303 401.5,291" fill="none" stroke-linecap="round" stroke="rgb(127, 75, 79)" stroke-width="16.2px"></path>
          <g>
            <circle cx="387.68" cy="357.94" r="6.07" fill="rgb(188, 119, 108)"></circle>
            <circle data-name="Oval 1 -Copy-3" cx="428.66" cy="357.94" r="8.1" fill="rgb(188, 119, 108)"></circle>
            <circle data-name="Oval 2 -Copy-3" cx="410.28" cy="384.51" r="8.1" fill="rgb(188, 119, 108)"></circle>
          </g>
          <path d="M249.38,231.94h62.91v61.79c0,36.19-10.49,32.08-10.49,55.07s-30.24,44.65,10.49,47.74c12.64,0,29.54-8.75,29.54-8.75,0,0,26.32,2.55,26.32-9.3s-14.97-10.89-21.26-6.98" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(127, 75, 79)" stroke-width="16.2px"></path>
          <g>
            <line class="brow-r" data-name="Shape 18 -Copy-3" x1="354.18" y1="232.35" x2="431.02" y2="231.01" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(127, 75, 79)" stroke-width="16.2px"></line>
          </g>
        </g>
        <g>
          <path data-name="ShapeCopy16.00,-4.00" d="M299.66,445.38c12.61-24.49,28.54-14.02,36.07-14.65,7.54-.62,38.19-11.22,54.74,14.65-4.85,10.97-8.61,17.42-11.29,19.34-11.91,8.57-23.62,3.65-32.57,3.65-6.79,0-21.89-1.41-38.84-11.88-2.37-1.46-5.07-5.17-8.11-11.11Z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(127, 75, 79)" stroke-width="14.58px"></path>
          <path data-name="LineCopy-5.00,-4.00" d="M381.1,451.74c-3.13-1.61-11.78-3.28-21.34-3.19-6.28,.06-14.29,1.46-16.67,2.07-5.98,1.54-8.23,1.12-9.5,1.12s-5.72-1.12-14.79-1.12-12.18,2-14.83,6.01c-2.65,4.01-4.68,17.9,12.05,19.16,16.72,1.26,10.83-9.32,33.15,.49,12.12,5.33,23.21,.68,27.66-5.55,3.75-5.24,9.44-16.33,9.44-16.33l-5.18-2.66Z" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(127, 75, 79)" stroke-width="14.58px" fill="rgb(188, 119, 108)"></path>
        </g>
      </g>
    </svg>
  </div>
  </teleport>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// How far down the page counts as "at the top" (the nav links and the chat
// button come back past it).
const TOP = 24;
const desktop = () => window.matchMedia('(min-width: 768px) and (orientation: landscape)').matches;
const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// The pose the figure scrolls out to: straight down on phones, down and out
// to the right on desktop, and zoomed in as it goes. It scales from its feet,
// so the bottom edge stays on the bottom of the screen and nothing shows
// under it. Functions, so a resize re-reads the layout.
// The distances clear the zoomed figure (1.3x is 30% taller and wider) with
// room to spare, so not even the top of the head is left on the screen.
const OUT = {
  xPercent: () => (desktop() ? 115 : 0),
  yPercent: () => (desktop() ? 35 : 145),
  scale: 1.3,
};
const REST = { xPercent: 0, yPercent: 0, scale: 1 };

// Coming in, the figure leans into its travel (up and to the left on
// desktop, so its top tips left; straight up on phones, a smaller lean) and
// then settles back upright. The scroll does the same: it leans with the
// direction and speed you scroll, LEAN_PER degrees per 1000px/s up to
// LEAN_MAX, and springs back once the scroll stops.
const TILT_IN = () => (desktop() ? -5 : -3);
const LEAN_PER = 2.5;
const LEAN_MAX = 6;
// Going out it lags first: it leans back in toward the page, LAG times the
// lean the scroll's speed calls for, then swings over toward the edge it's
// leaving by. Both scale with speed, so a slow drag barely moves it.
const LAG = 0.5;
// One small overshoot and settle, not a wobble.
const SPRING = { duration: 0.45, ease: 'back.out(1.4)' };

// Phones: where the top of the head goes. Aim for 45% of the way down the
// screen (55% of it showing the figure), then keep the head over the hero
// title's last line by at least MIN_OVERLAP and at most MAX_OVERLAP of the
// title's font size: on a tall screen it comes up to meet the words, on a
// short one it stops before it covers them.
// Measured against the screen with the browser's bars showing (svh), which
// doesn't change as the bars slide away, and the figure is pinned by the top
// of its head, so the overlap stays the same with the bars or without them.
// The frame reaches the bottom of the screen with the bars gone (lvh); with
// them showing, the bars cover the bottom of the shirt.
const HEAD_TOP = 0.45;
const MIN_OVERLAP = 0.12;
const MAX_OVERLAP = 0.35;
// The drawing's frame runs from the top of the head (104 units down) to the
// crop at 820.
const HEAD = 104;
const CROP = 820;

// The eyes. They move at most EYE_REACH drawing units toward the pointer,
// reaching it once the pointer is EYE_FULL screen px away. A blink shuts them
// to LID_SHUT of their height for BLINK_MS, every BLINK_MIN to BLINK_MAX ms.
const EYE_REACH = 10;
// Looking up they travel further: the eyes sit low under the brows, so the
// same reach upward barely reads. Looking left they travel less, since the
// left-hand eye already sits near the edge of the face.
const EYE_REACH_UP = 15;
const EYE_REACH_LEFT = 5;
// Right is the way the face is turned from, so there's room to go further.
const EYE_REACH_RIGHT = 15;
const EYE_FULL = 240;
const LID_SHUT = 0.12;
const BLINK_MS = 130;
const BLINK_MIN = 2500;
const BLINK_MAX = 6000;
// The face is drawn three-quarter, turned to the left, so its resting eyes
// look past you. Over the face they shift this far (drawing units) to meet
// your eye instead.
const AT_YOU = { x: EYE_REACH, y: 0 };

const viewportUnit = (unit) => {
  const probe = document.createElement('div');
  probe.style.cssText = `position:fixed;top:0;height:100${unit};visibility:hidden;pointer-events:none`;
  document.body.appendChild(probe);
  const h = probe.getBoundingClientRect().height || window.innerHeight;
  probe.remove();
  return h;
};

const phoneLayout = () => {
  const small = viewportUnit('svh');
  const large = Math.max(viewportUnit('lvh'), small);
  let head = small * HEAD_TOP;
  const title = document.querySelector('#hero-title');
  if (title) {
    const bottom = title.getBoundingClientRect().bottom + window.pageYOffset;
    const size = parseFloat(getComputedStyle(title).fontSize) || 0;
    head = Math.min(Math.max(head, bottom - size * MAX_OVERLAP), bottom - size * MIN_OVERLAP);
  }
  const height = ((large - head) * CROP) / (CROP - HEAD);
  return { height, top: head - (height * HEAD) / CROP };
};

export default {
  name: 'HomeAvatar',
  data() {
    return { atTop: null, ctx: null };
  },
  mounted() {
    const el = this.$refs.figure;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.size, { passive: true });
    this.onScroll();
    this.size();
    // Again once the webfont is in and the title's fade has settled, since
    // both move where its last line ends.
    if (document.fonts) document.fonts.ready.then(this.size);
    this.sizeTimer = setTimeout(this.size, 1200);
    // Pressing the face winks even with reduced motion, since you asked for
    // it; following and blinking on their own don't.
    this.pointer = null;
    this.hovering = false;
    this.winking = false;
    if (!reduced()) {
      window.addEventListener('pointermove', this.onPointerMove, { passive: true });
      this.scheduleBlink();
    }
    if (reduced()) return;
    this.ctx = gsap.context(() => {
      gsap.set(el, { transformOrigin: '50% 100%' });
      let leaning = false;
      let lagUntil = 0;
      const settle = () => {
        leaning = false;
        gsap.to(el, { rotation: 0, ...SPRING, overwrite: 'auto' });
      };
      const lean = (self) => {
        const v = self.getVelocity();
        const r = gsap.utils.clamp(-LEAN_MAX, LEAN_MAX, (v / 1000) * LEAN_PER);
        const now = performance.now();
        if (!leaning && v > 0) {
          // The start of a move out: lean back in, then over toward the
          // edge. Updates wait for it to play out (lagUntil).
          lagUntil = now + 370;
          gsap
            .timeline()
            .to(el, { rotation: -r * LAG, duration: 0.12, ease: 'power1.out', overwrite: 'auto' })
            .to(el, { rotation: r, duration: 0.25, ease: 'power2.inOut' });
        } else if (now >= lagUntil) {
          gsap.to(el, { rotation: r, duration: 0.15, ease: 'power1.out', overwrite: 'auto' });
        }
        leaning = true;
        // Settle once the scroll stops, but never before the lag has played.
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(settle, Math.max(120, lagUntil - now + 60));
      };
      // The scroll drives the figure: the first half screen of scrolling takes
      // it from standing to gone, and scrolling back brings it back, at the
      // speed you scroll. A short scrub smooths a flick of the wheel.
      const scrub = () =>
        gsap.fromTo(el, REST, {
          ...OUT,
          ease: 'power1.in',
          immediateRender: false,
          scrollTrigger: {
            start: 0,
            end: () => window.innerHeight * 0.5,
            scrub: 0.3,
            invalidateOnRefresh: true,
            onUpdate: lean,
          },
        });
      if (window.pageYOffset > 0) {
        scrub();
        ScrollTrigger.refresh();
        return;
      }
      // Loading at the top: the figure comes in leaning, the scroll takes
      // over as it lands, and it springs upright.
      gsap
        .timeline()
        .fromTo(
          el,
          { ...OUT, rotation: 0 },
          { ...REST, rotation: TILT_IN, duration: 0.38, ease: 'power3.out' }
        )
        .call(scrub)
        .to(el, { rotation: 0, ...SPRING });
    });
  },
  beforeUnmount() {
    if (this.ctx) this.ctx.revert();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.size);
    clearTimeout(this.sizeTimer);
    clearTimeout(this.blinkTimer);
    clearTimeout(this.settleTimer);
    cancelAnimationFrame(this.lookFrame);
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onFaceRelease);
    window.removeEventListener('pointercancel', this.onFaceRelease);
    document.documentElement.classList.remove('home-at-top');
  },
  methods: {
    onPointerMove(e) {
      this.pointer = { x: e.clientX, y: e.clientY };
      if (!this.lookFrame) this.lookFrame = requestAnimationFrame(this.look);
    },
    // Each eye moves toward the pointer from where it is on the screen, so
    // the two converge on something close. Over the face they turn to meet
    // yours (AT_YOU) and hold still.
    look() {
      this.lookFrame = 0;
      [this.$refs.eyeL, this.$refs.eyeR].forEach((eye) => {
        if (!eye) return;
        // Held on you while hovered or pressed, wherever the pointer goes.
        const atYou = this.hovering || this.winking;
        let x = atYou ? AT_YOU.x : 0;
        let y = atYou ? AT_YOU.y : 0;
        if (this.pointer && !atYou) {
          const box = eye.getBoundingClientRect();
          const dx = this.pointer.x - (box.left + box.width / 2);
          const dy = this.pointer.y - (box.top + box.height / 2);
          const dist = Math.hypot(dx, dy) || 1;
          const reach = EYE_REACH * Math.min(dist / EYE_FULL, 1);
          x = (dx / dist) * reach * ((dx < 0 ? EYE_REACH_LEFT : EYE_REACH_RIGHT) / EYE_REACH);
          y = (dy / dist) * reach * (dy < 0 ? EYE_REACH_UP / EYE_REACH : 1);
        }
        eye.style.setProperty('--eye-x', `${x.toFixed(2)}px`);
        eye.style.setProperty('--eye-y', `${y.toFixed(2)}px`);
      });
    },
    setLid(eye, shut) {
      if (eye) eye.style.setProperty('--lid', shut ? LID_SHUT : 1);
    },
    scheduleBlink() {
      const wait = BLINK_MIN + Math.random() * (BLINK_MAX - BLINK_MIN);
      this.blinkTimer = setTimeout(this.blink, wait);
    },
    // No blink during a wink, or while the pointer is on the face, where the
    // eyes hold still on you. The next blink waits for its turn.
    blink() {
      if (this.winking || this.hovering) {
        this.scheduleBlink();
        return;
      }
      const { eyeL, eyeR } = this.$refs;
      this.setLid(eyeL, true);
      this.setLid(eyeR, true);
      this.blinkTimer = setTimeout(() => {
        this.setLid(eyeL, false);
        this.setLid(eyeR, false);
        this.scheduleBlink();
      }, BLINK_MS);
    },
    onFaceEnter() {
      this.hovering = true;
      this.$refs.figure.classList.add('is-hovering');
      this.setLid(this.$refs.eyeL, false);
      this.setLid(this.$refs.eyeR, false);
      this.look();
    },
    onFaceLeave() {
      this.hovering = false;
      this.$refs.figure.classList.remove('is-hovering');
      this.look();
    },
    // The wink holds while the button (or finger) is down, and lets go
    // wherever it's released. The eyes stay on you until the pointer leaves.
    onFacePress(e) {
      if (e.button !== undefined && e.button !== 0) return;
      this.winking = true;
      // A blink already under way opens before the wink lands.
      this.setLid(this.$refs.eyeL, false);
      this.setLid(this.$refs.eyeR, false);
      this.$refs.figure.classList.add('is-winking');
      this.look();
      window.addEventListener('pointerup', this.onFaceRelease);
      window.addEventListener('pointercancel', this.onFaceRelease);
    },
    onFaceRelease() {
      this.winking = false;
      this.$refs.figure.classList.remove('is-winking');
      this.look();
      window.removeEventListener('pointerup', this.onFaceRelease);
      window.removeEventListener('pointercancel', this.onFaceRelease);
    },
    size() {
      const el = this.$refs.figure;
      if (!el) return;
      if (desktop()) {
        el.style.removeProperty('--avatar-h');
        el.style.removeProperty('--avatar-y');
        return;
      }
      const { height, top } = phoneLayout();
      el.style.setProperty('--avatar-h', `${height}px`);
      el.style.setProperty('--avatar-y', `${top}px`);
      ScrollTrigger.refresh();
    },
    onScroll() {
      const atTop = window.pageYOffset <= TOP;
      if (atTop === this.atTop) return;
      this.atTop = atTop;
      document.documentElement.classList.toggle('home-at-top', atTop);
      // Reduced motion: no scrubbing, the figure is there at the top and
      // gone below it.
      if (reduced()) this.$refs.figure.style.visibility = atTop ? '' : 'hidden';
    },
  },
};
</script>

<style scoped lang="scss">
.home-avatar {
  position: fixed;
  /* Phones: head and shoulders, cropped just above where the arms begin (820
     of the drawing's 1125), at the right edge with a fifth of it past the
     side. Pinned by the top of the head (104 units down the drawing), which
     the script places over the hero title's last line (phoneLayout). Until
     it runs, the head sits 45% of the way down and the frame runs to the
     bottom of the screen. The drawing runs on below the frame. */
  --avatar-h: calc(55lvh * 820 / 716);
  --avatar-y: calc(45svh - var(--avatar-h) * 104 / 820);
  inset-block-start: var(--avatar-y);
  inset-inline-end: calc(-0.2 * var(--avatar-h) * 900 / 820);
  block-size: var(--avatar-h);
  aspect-ratio: 900 / 820;
  /* Not clipped: the drawing runs on below the frame (to 1125), off the
     bottom of the screen at rest, so when the figure tilts the shirt carries
     on past the crop instead of showing a cut edge. */
  overflow: visible;
  /* In front of the page (whose highest layer, inside the cards, is 100),
     and under the full-screen menu and its overlay (--z-overlay, 999), so
     the menu covers it while it fades out. */
  z-index: 500;
  pointer-events: none;
  user-select: none;
  will-change: transform;

  /* The shirt is the other theme's page colour: brown on the yellow page,
     yellow on the brown one. Its folds are a shade off the fill. */
  --avatar-shirt: var(--color-skin-deep);
  --avatar-shirt-fold: color-mix(in srgb, var(--color-skin-deep), white 18%);
  /* The face's lines (brows, eyes, nose, mouth) were a plum, #7f4b4f, that
     read apart from the page. Pulled most of the way to the site's brown so
     they sit in the same family as the shirt and the text. */
  --avatar-line: color-mix(in oklab, var(--color-skin-deep) 60%, rgb(127, 75, 79));

  svg {
    display: block;
    inline-size: 100%;
    block-size: auto;
  }
  :deep(.shirt) {
    fill: var(--avatar-shirt);
  }
  :deep(.shirt-fold) {
    stroke: var(--avatar-shirt-fold);
  }
  // Matched on the drawing's own colour, so the SVG markup stays as exported.
  :deep([stroke='rgb(127, 75, 79)']) {
    stroke: var(--avatar-line);
  }
  :deep([fill='rgb(127, 75, 79)']) {
    fill: var(--avatar-line);
  }

  /* The face is the one part that takes the pointer: hover it and the eyes
     look at you, press it and one winks. */
  :deep(.face) {
    pointer-events: auto;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  /* Every line in the drawing at --avatar-stroke of its exported width, a
     little lighter than the original. Matched on the exported widths, so the
     markup stays as it came. */
  --avatar-stroke: 0.85;
  :deep([stroke-width='16.2px']) {
    stroke-width: calc(16.2px * var(--avatar-stroke));
  }
  :deep([stroke-width='14.58px']) {
    stroke-width: calc(14.58px * var(--avatar-stroke));
  }
  :deep([stroke-width='14px']) {
    stroke-width: calc(14px * var(--avatar-stroke));
  }

  /* The right-hand brow lifts while the face is hovered and drops into the
     wink while it's pressed. The brow and the wink share one short
     transition, --avatar-snap, so they land together. */
  --avatar-snap: 0.06s ease-out;
  :deep(.brow-r) {
    transition: transform var(--avatar-snap);
  }
  &.is-hovering :deep(.brow-r) {
    transform: translateY(-9px);
  }
  &.is-winking :deep(.brow-r),
  &.is-hovering.is-winking :deep(.brow-r) {
    transform: translateY(7px);
  }

  :deep(.wink) {
    opacity: 0;
    transition: opacity var(--avatar-snap);
  }
  &.is-winking {
    :deep(.wink) {
      opacity: 1;
    }
    :deep(.fa-eye-r) {
      opacity: 0;
    }
  }

  /* The eyes move by --eye-x/--eye-y (drawing units) and shut by --lid,
     around their own centre. */
  :deep(.fa-eye) {
    transform-box: fill-box;
    transform-origin: center;
    transform: translate(var(--eye-x, 0), var(--eye-y, 0)) scaleY(var(--lid, 1));
    transition:
      transform 0.12s ease-out,
      opacity var(--avatar-snap);
  }

  /* Desktop (a landscape window): the same crop as on phones, above the
     arms, at the right edge with a fifth of it past the side. Bigger: the
     top of the head sits 10% of the way down the screen, so the frame is
     90svh * 820 / 716 tall and fills most of the screen's height. It may
     overlap the hero's text. */
  @media only screen and (min-width: 768px) and (orientation: landscape) {
    --avatar-h: calc(90svh * 820 / 716);
    inset-block-start: auto;
    inset-block-end: 0;
    inset-inline-end: calc(-0.2 * var(--avatar-h) * 900 / 820);
    block-size: var(--avatar-h);
  }

}
</style>

<style lang="scss">
:root.dark-theme .home-avatar {
  --avatar-shirt: var(--color-banana);
  --avatar-shirt-fold: color-mix(in srgb, var(--color-banana), black 14%);
}
@media (prefers-color-scheme: dark) {
  :root:not(.light-theme) .home-avatar {
    --avatar-shirt: var(--color-banana);
    --avatar-shirt-fold: color-mix(in srgb, var(--color-banana), black 14%);
  }
}

/* The figure steps out of the way while the full-screen menu is open
   (FullscreenMenu puts .menu-open on <html>), and is back when it closes. */
.home-avatar {
  transition:
    opacity 0.2s ease,
    visibility 0.2s;
}
:root.menu-open .home-avatar {
  opacity: 0;
  visibility: hidden;
}

/* While the figure is showing, the top of the home page is the hero and the
   figure alone: the chat button and, on desktop, the nav's links (Library,
   Menu) step aside, and come back the moment you scroll. The name stays. */
.navbar .links,
.chat-button {
  transition:
    opacity 0.2s ease,
    visibility 0.2s;
}
:root.home-at-top:not(.menu-open) {
  .chat-button {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }
  /* Desktop only: on phones the menu icon stays, so the menu is always one
     tap away. With the menu open none of this applies, so its Close link
     shows. */
  @media only screen and (min-width: 768px) {
    .navbar .links {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }
  }
}
</style>
